import * as React from 'react';
import '../../style/about.css';
import '../../style/utils.css';
import LeadForm from '../leadForm';
import Carousel from './carousel';
import AboutDetails from './aboutDetails';
import { useResources, useComponentResources } from '../../store/resourcesProvider';

function About() {
    const [showLeadForm, setShowLeadForm] = React.useState(false);
    const resources = useResources();
    const pageRes = useComponentResources('About', ['About.Heading','About.P1','About.P2','About.P3','About.P4']);

    const Images = ['/voice1.jpg', '/relax.jpg','/voice1.jpg'];
    return (
        <>
            <div className="page-padding">

                <h1>{pageRes['About.Heading'] ?? resources.get('About.Heading','קול הנשימה  - מראה לנפש שלנו')}</h1>
                <p>{pageRes['About.P1'] ?? resources.get('About.P1','שנים של לימוד אצל מיטב המסגרות והמורים,')}</p>
                <p>{pageRes['About.P2'] ?? resources.get('About.P2','בראתי דרך ייחודית בהוראת פיתוח הקול.')}</p>
                <p>{pageRes['About.P3'] ?? resources.get('About.P3','אשמח לחלוק איתך את הכלים שרכשתי וללוות אותך בתהליך עד לרווחה הנפשית שלך.')}</p>
                <p>{pageRes['About.P4'] ?? resources.get('About.P4','המפגשים מועברים בסטודיו מלא בכלי נגינה וציוד תנועה המאפשר לקול הפנימי שלך לצאת לאויר העולם...')}</p>
            </div>

            <div className="flex-container page-padding">
                <div className="column column1">

                    <LeadForm showDiscountImage={true}
                        onSubmit={() => setShowLeadForm(false)} />
                </div>

                <div className="column column2">
                    <div className="imgDiv">
                        <Carousel images={Images} />
                    </div>
                </div>
            </div>
            <div>
                <AboutDetails/>
            </div>
        </>
    );
}

export default About;